/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, noop, reaction } from '@reatom/framework'

import { FunExploreRoute, RootRoute } from '@root/features/routing'
import { routerLocationAtom } from '@root/shared/lib/react-router'

import { Platform } from '../model'

export const platformAtom = atom<Platform.Platform>(
  Platform.Terminal,
  'platformAtom',
)

export const setPlatformAction = action((ctx, platform: Platform.Platform) => {
  platformAtom(ctx, platform)
})

export const scrollPageToTopEvent = action(noop, 'scrollPageToTopEvent')

const routeReaction = reaction((ctx) => {
  const route = ctx.spy(routerLocationAtom)
  if (FunExploreRoute.match(route.pathname)) {
    platformAtom(ctx, Platform.Pump)
  }
  if (RootRoute.match(route.pathname)) {
    platformAtom(ctx, Platform.Terminal)
  }
})

export const initializePlatformAction = action((ctx) => {
  routeReaction(ctx)
})
